const identifiers = ["dropdown", "document-details-dropdown", "invoice-actions-dropdown"]

export default function closeOtherDropdowns(application, currentElement) {
  document.querySelectorAll(identifiers.map(identifier => `[data-controller~="${identifier}"]`).join(", ")).forEach(element => {
    if (element === currentElement) return

    identifiers.forEach(identifier => application.getControllerForElementAndIdentifier(element, identifier)?.close())
  })
}
